// Этап 6, раздел 5 «Промокоды» (docs/PLAN.md) — список + генерация. Только пробный доступ
// (FREE_PERIOD), та же логика, что у scripts/generate_promo_code.py.
import { type FormEvent, useEffect, useState } from "react";

import {
  type AdminPlan,
  type AdminPromoCode,
  ApiError,
  createPromoCode,
  fetchPlans,
  fetchPromoCodes,
} from "../api/client";
import { PromoCodeRow } from "../components/PromoCodeRow";

export function PromoCodesScreen() {
  const [codes, setCodes] = useState<AdminPromoCode[] | null>(null);
  const [plans, setPlans] = useState<AdminPlan[]>([]);
  const [loadError, setLoadError] = useState<string | null>(null);

  const [planId, setPlanId] = useState("");
  const [days, setDays] = useState("7");
  const [validDays, setValidDays] = useState("30");
  const [creating, setCreating] = useState(false);
  const [createError, setCreateError] = useState<string | null>(null);
  const [lastCreatedCode, setLastCreatedCode] = useState<string | null>(null);

  function loadCodes() {
    setLoadError(null);
    fetchPromoCodes()
      .then(setCodes)
      .catch((err) => {
        setLoadError(err instanceof ApiError ? err.message : "Не удалось загрузить промокоды");
      });
  }

  useEffect(() => {
    loadCodes();
    // Активные тарифы для выпадающего списка — тот же принцип, что у _pick_plan в
    // scripts/generate_promo_code.py (не даёт привязать код к архивному тарифу).
    fetchPlans()
      .then((all) => setPlans(all.filter((p) => p.is_active)))
      .catch(() => undefined);
  }, []);

  async function onCreate(event: FormEvent) {
    event.preventDefault();
    if (!planId) {
      return;
    }
    setCreating(true);
    setCreateError(null);
    setLastCreatedCode(null);
    try {
      const promo = await createPromoCode({
        plan_id: Number(planId),
        days: Number(days),
        valid_days: Number(validDays),
      });
      setLastCreatedCode(promo.code);
      loadCodes();
    } catch (err) {
      setCreateError(err instanceof ApiError ? err.message : "Не удалось создать промокод");
    } finally {
      setCreating(false);
    }
  }

  return (
    <div className="screen">
      <h2>Промокоды</h2>

      <form
        onSubmit={onCreate}
        className="card"
        style={{ marginBottom: 24, display: "grid", gap: 12, gridTemplateColumns: "repeat(4, 1fr)", alignItems: "end" }}
      >
        <div className="field" style={{ marginBottom: 0, gridColumn: "span 2" }}>
          <label>Тариф</label>
          <select required value={planId} onChange={(e) => setPlanId(e.target.value)}>
            <option value="" disabled>
              — выберите —
            </option>
            {plans.map((p) => (
              <option key={p.id} value={p.id}>
                {p.title}
              </option>
            ))}
          </select>
        </div>
        <div className="field" style={{ marginBottom: 0 }}>
          <label>Доступ, дней</label>
          <input required type="number" min={1} value={days} onChange={(e) => setDays(e.target.value)} />
        </div>
        <div className="field" style={{ marginBottom: 0 }}>
          <label>Окно погашения, дней</label>
          <input required type="number" min={1} value={validDays} onChange={(e) => setValidDays(e.target.value)} />
        </div>
        <div style={{ gridColumn: "span 4" }}>
          <button type="submit" className="primary" disabled={creating || !planId}>
            {creating ? "Создаём…" : "Сгенерировать код"}
          </button>
          {lastCreatedCode && (
            <span style={{ marginLeft: 12 }}>
              Готово: <code>{lastCreatedCode}</code>
            </span>
          )}
        </div>
        {createError && <div className="error-text" style={{ gridColumn: "span 4", marginBottom: 0 }}>{createError}</div>}
      </form>

      {loadError && <div className="error-text">{loadError}</div>}

      {codes && (
        <div className="card" style={{ padding: 0, overflow: "auto" }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>Код</th>
                <th>Тариф</th>
                <th>Доступ</th>
                <th>Окно действия</th>
                <th>Статус</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {codes.length === 0 ? (
                <tr>
                  <td colSpan={6}>Промокодов пока нет.</td>
                </tr>
              ) : (
                codes.map((promo) => (
                  <PromoCodeRow key={promo.id} promo={promo} onChanged={loadCodes} />
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
